import {
  MembershipStatsFragmentDoc,
  RecentMembersFragmentDoc,
  MentorGroupsFragmentDoc
} from "@pathwright/graphql-client/src/generated"
import numeral from "numeral"
import pluralize from "pluralize"
import { usePathwrightContext } from "../pathwright/PathwrightContext"
import CommunityPreview from "./CommunityPreview"
import Place from "./Place"

const CommunityPlace = ({ recentMembers, membershipStats, mentorGroups }) => {
  const { school } = usePathwrightContext()
  if (!recentMembers) return null
  const hasMembers = recentMembers.edges.length > 0
  return (
    <Place
      name="Community"
      icon="multi-user"
      color="#6A9FCB"
      onLaunch={(to) => window.App && window.App.navigate(to)}
      to="/community/members/"
      action="Manage members & groups"
      isBlank={!hasMembers}
      blankImage="community"
      blankDescription={`See everyone learning & teaching on ${school.name}`}
      footer={
        hasMembers &&
        membershipStats && (
          <p>
            {numeral(membershipStats.total).format("0,0")}{" "}
            {pluralize("member", membershipStats.total)}
            {" • "}
            {numeral(mentorGroups?.total).format("0,0")}{" "}
            {pluralize("group", mentorGroups?.total)}
          </p>
        )
      }
    >
      {hasMembers && (
        <CommunityPreview
          members={recentMembers.edges.map((edge) => edge.node.user)}
        />
      )}
    </Place>
  )
}

CommunityPlace.displayName = "CommunityPlace"

CommunityPlace.fragments = {
  membershipStats: MembershipStatsFragmentDoc,
  recentMembers: RecentMembersFragmentDoc,
  mentorGroups: MentorGroupsFragmentDoc
}

export default CommunityPlace
